const stripeClient = (options) => {
  return {
    id: "stripe-client",
    $InferServerPlugin: {},
    pathMethods: {
      "/subscription/restore": "POST",
      "/subscription/billing-portal": "POST"
    }
  };
};

export { stripeClient };
